module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_NL-9e6d9b422418ff660b75aebf808fdeac.svg";